import { computed, ref } from 'vue'

import axios from 'axios'

const noncompliance_model_cost_centers = ref([])
const noncompliance_model_cost_center_filters = ref({})
const filtered_noncompliance_model_cost_centers = ref([])

export default function useNoncomplianceModelCostCenters() {
  const listNoncomplianceModelCostCenters = async () => {
    axios
      .get('/api/noncompliance_model_cost_centers/all')
      .then(function (response) {
        noncompliance_model_cost_centers.value =
          filtered_noncompliance_model_cost_centers.value = response.data.data
      })
      .catch(function () {})
  }

  return {
    noncompliance_model_cost_centers: computed(
      () => noncompliance_model_cost_centers.value,
    ),
    noncompliance_model_cost_center_filters: noncompliance_model_cost_center_filters,
    filtered_noncompliance_model_cost_centers: computed(
      () => filtered_noncompliance_model_cost_centers.value,
    ),
    listNoncomplianceModelCostCenters,
  }
}
